module.exports = __webpack_public_path__ + "img/icon-tixing.8381fe33.svg";